import AccountCreateController from "./controller";
import AccountCreateComponents from "./components/module";

const modul = angular
    .module("AccountCreateModule", [AccountCreateComponents])
    .controller("AccountCreateController", AccountCreateController);

export default modul.name;
